import * as React from 'react';
import { Toast } from '@syncfusion/ej2-notifications';
import { ComponentBase, applyMixins } from '@syncfusion/ej2-react-base';
/**
 * Represents the React Toast Component
 * ```html
 * <Toast></Toast>
 * ```
 */
export class ToastComponent extends Toast {
    constructor(props) {
        super(props);
        this.initRenderCalled = false;
        this.checkInjectedModules = false;
        this.directivekeys = { 'buttonModelProps': 'buttonModelProp' };
        this.statelessTemplateProps = ["content"];
        this.templateProps = null;
        this.immediateRender = false;
        this.isReactMock = true;
        this.portals = [];
    }
    render() {
        this.isReactMock = false;
        if (((this.element && !this.initRenderCalled) || this.refreshing) && !this.isReactForeceUpdate) {
            super.render();
            this.initRenderCalled = true;
        }
        else {
            return React.createElement('div', this.getDefaultAttributes(), [].concat(this.props.children, this.portals));
        }
    }
}
applyMixins(ToastComponent, [ComponentBase, React.Component]);
